import { useDemoMode } from '../demoMode';
import { FlaskConical, Database } from 'lucide-react';

interface Props {
  collapsed?: boolean;
}

export default function DemoModeToggle({ collapsed }: Props) {
  const [demo, setDemo] = useDemoMode();

  if (collapsed) {
    return (
      <button
        onClick={() => setDemo(!demo)}
        title={demo ? 'Mode Démo actif (cliquer pour revenir au réel)' : 'Mode Réel actif (cliquer pour passer en démo)'}
        className={`w-full flex items-center justify-center py-2.5 rounded-lg transition-all ${
          demo
            ? 'bg-orange-500/20 text-orange-300 ring-1 ring-orange-500/40'
            : 'bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20 hover:bg-emerald-500/20'
        }`}
      >
        {demo ? <FlaskConical size={16} strokeWidth={2} /> : <Database size={16} strokeWidth={1.5} />}
      </button>
    );
  }

  return (
    <div
      className={`rounded-lg p-2.5 transition-all ${
        demo
          ? 'bg-orange-500/15 ring-1 ring-orange-500/40'
          : 'bg-slate-800/40 ring-1 ring-slate-700/40'
      }`}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          {demo ? (
            <FlaskConical size={14} className="text-orange-300 shrink-0" strokeWidth={2} />
          ) : (
            <Database size={14} className="text-emerald-400 shrink-0" strokeWidth={1.5} />
          )}
          <div className="min-w-0">
            <div className={`text-[11px] font-semibold leading-tight ${demo ? 'text-orange-200' : 'text-slate-200'}`}>
              {demo ? 'Mode Démo' : 'Mode Réel'}
            </div>
            <div className="text-[9px] text-slate-400 leading-tight truncate">
              {demo ? 'Données test isolées' : 'Vraies données'}
            </div>
          </div>
        </div>
        {/* Switch */}
        <button
          role="switch"
          aria-checked={demo}
          onClick={() => setDemo(!demo)}
          className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
            demo ? 'bg-orange-500' : 'bg-slate-600'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
              demo ? 'translate-x-[18px]' : 'translate-x-0.5'
            }`}
          />
        </button>
      </div>
    </div>
  );
}
